var _dec, _class, _temp;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

//@ts-nocheck

/**
 * @license
 * Copyright Akveo. All Rights Reserved.
 * Licensed under the MIT License. See License.txt in the project root for license information.
 */
import React from 'react';
import { Platform, StyleSheet, View } from 'react-native';
import { FalsyFC, FalsyText, TouchableWeb } from "../../devsupport";
import { Interaction, styled } from "../../theme";
export
/**
 * A single item rendered in List.
 * Items should be rendered within List by providing them through `renderItem` property to provide a usable component.
 *
 * @extends React.Component
 *
 * @property {ReactText | (TextProps) => ReactElement} title - String, number or a function component
 * to render within the item.
 * If it is a function, expected to return a Text.
 *
 * @property {ReactText | (TextProps) => ReactElement} description - String, number or a function component
 * to render within the item.
 * If it is a function, expected to return a Text.
 *
 * @property {(ImageProps) => ReactElement} accessoryLeft - Function component
 * to render to start of the text.
 * Expected to return an Image.
 *
 * @property {(ViewProps) => ReactElement} accessoryRight - Function component
 * to render to end of the text.
 *
 * @property {ReactNode} children - Component to render within the item.
 * Useful when needed to render a custom item and get a feedback when it is pressed.
 * If provided, *title* and other properties will be ignored.
 *
 * @property {TouchableOpacityProps} ...TouchableOpacityProps - Any props applied to TouchableOpacity component.
 *
 * @overview-example ListItemSimpleUsage
 *
 * @overview-example ListItemStyling
 * List Item and it's inner views can be styled by passing them as function components.
 *
 * In most cases this is redundant, if [custom theme is configured](guides/branding).
 * ```
 * import { ListItem, Text } from '../..';
 *
 * <ListItem
 *   title={evaProps => <Text {...evaProps}>TITLE</Text>}
 *   description={evaProps => <Text {...evaProps}>DESCRIPTION</Text>}
 * />
 * ```
 */
let ListItem = (_dec = styled('ListItem'), _dec(_class = (_temp = class ListItem extends React.Component {
  constructor(...args) {
    super(...args);

    _defineProperty(this, "onPressIn", event => {
      this.props.eva.dispatch([Interaction.ACTIVE]);
      this.props.onPressIn && this.props.onPressIn(event);
    });

    _defineProperty(this, "onPressOut", event => {
      this.props.eva.dispatch([]);
      this.props.onPressOut && this.props.onPressOut(event);
    });

    _defineProperty(this, "getComponentStyle", source => {
      const {
        iconWidth,
        iconHeight,
        iconMarginHorizontal,
        iconTintColor,
        titleMarginHorizontal,
        titleFontFamily,
        titleFontSize,
        titleFontWeight,
        titleColor,
        descriptionFontFamily,
        descriptionFontSize,
        descriptionFontWeight,
        descriptionColor,
        descriptionMarginHorizontal,
        accessoryMarginHorizontal
      } = source,
            containerParameters = _objectWithoutProperties(source, ["iconWidth", "iconHeight", "iconMarginHorizontal", "iconTintColor", "titleMarginHorizontal", "titleFontFamily", "titleFontSize", "titleFontWeight", "titleColor", "descriptionFontFamily", "descriptionFontSize", "descriptionFontWeight", "descriptionColor", "descriptionMarginHorizontal", "accessoryMarginHorizontal"]);

      return {
        container: containerParameters,
        icon: {
          width: iconWidth,
          height: iconHeight,
          marginHorizontal: iconMarginHorizontal,
          tintColor: iconTintColor
        },
        title: {
          marginHorizontal: titleMarginHorizontal,
          fontFamily: titleFontFamily,
          fontSize: titleFontSize,
          fontWeight: titleFontWeight,
          color: titleColor
        },
        description: {
          color: descriptionColor,
          fontFamily: descriptionFontFamily,
          fontSize: descriptionFontSize,
          fontWeight: descriptionFontWeight,
          marginHorizontal: descriptionMarginHorizontal
        },
        accessory: {
          marginHorizontal: accessoryMarginHorizontal
        }
      };
    });

    _defineProperty(this, "renderTemplateChildren", (props, evaStyle) => {
      return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(FalsyFC, {
        style: evaStyle.icon,
        component: props.accessoryLeft
      }), /*#__PURE__*/React.createElement(View, {
        style: styles.contentContainer
      }, /*#__PURE__*/React.createElement(FalsyText, {
        style: [evaStyle.title, styles.title],
        component: props.title
      }), /*#__PURE__*/React.createElement(FalsyText, {
        style: [evaStyle.description, styles.description],
        component: props.description
      })), /*#__PURE__*/React.createElement(FalsyFC, {
        style: evaStyle.icon,
        component: props.accessoryRight
      }));
    });
  }

  render() {
    const _this$props = this.props,
          {
      eva,
      style,
      children,
      title,
      description,
      accessoryLeft,
      accessoryRight
    } = _this$props,
          touchableProps = _objectWithoutProperties(_this$props, ["eva", "style", "children", "title", "description", "accessoryLeft", "accessoryRight"]);

    const evaStyle = this.getComponentStyle(eva.style);
    return /*#__PURE__*/React.createElement(TouchableWeb, _extends({}, touchableProps, {
      style: [evaStyle.container, styles.container, webStyles.container, style],
      onPressIn: this.onPressIn,
      onPressOut: this.onPressOut
    }), children || this.renderTemplateChildren(this.props, evaStyle));
  }

}, _temp)) || _class);
const styles = StyleSheet.create({
  container: {
    flexDirection: 'row',
    alignItems: 'center'
  },
  contentContainer: {
    flex: 1
  },
  title: {
    textAlign: 'left'
  },
  description: {
    textAlign: 'left'
  }
});
const webStyles = Platform.OS === 'web' && StyleSheet.create({
  container: {
    // @ts-ignore
    outlineWidth: 0
  }
});